import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  header: string;
  message: string;
  confirmMessage: string;
  cancelMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    this.header = data.header;
    this.message = data.message;
    this.confirmMessage = data.confirmMessage;
    this.cancelMessage = data.cancelMessage;
  }

  ngOnInit(): void {
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }


  closeDialog() {
    this.dialogRef.close();
  }


}
